<template>
  <div>
    <table class="tabla-pagos" v-if="pagos.length > 0">
      <tr>
        <th>Monto</th>
        <th>Fecha de Pago</th>
        <th>Comprobante</th>
        <th v-if="puedeBorrarAdjuntos">Acciones</th>
      </tr>
      <tr v-for="pago in pagos" :key="pago.pk">
        <td class="importe">{{ pago.monto | formatAsCurrency }}</td>
        <td>{{ pago.fechaDePago }}</td>
        <td>
        <attachment-list :adjuntos="pago.comprobantes" v-if="pago.comprobantes && pago.comprobantes.length > 0"></attachment-list>
        </td>
        <td v-if="puedeBorrarAdjuntos">
          <v-btn icon flat small @click="deleteDetalle(pago.pk)" class="pa-0 ma-0 mt-1"
            :disabled="!puedeBorrarAdjuntos">
            <v-tooltip bottom>
              <v-icon slot="activator" color="primary">delete</v-icon>
              <span>Eliminar</span>
            </v-tooltip>
          </v-btn>
        </td>
      </tr>
    </table>
    <span v-else-if="!canEdit || $store.getters.isSafRole" class="mensaje-sin-detalle">
      Este pago no tiene detalle de pagos asociados
    </span>
  </div>
</template>

<script>

import AttachmentList from './AttachmentList'

export default {
  props: {
    pagos: Array,
    canEdit: Boolean,
    puedeBorrarAdjuntos: Boolean
  },

  components: {
    AttachmentList
  },

  methods: {
    deleteDetalle (id) {
      this.$emit('deleteDetalle', id)
    }
  },

  filters: {
    formatAsCurrency (importe) {
      const monto = Number(importe).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return `$ ${monto}`
    }
  }
}
</script>

<style scoped>
.tabla-pagos {
  width: 100%;
}
.tabla-pagos tr:hover {
  background-color: rgb(200, 200, 200);
}
.tabla-pagos th {
  padding-top: 1rem;
  border-bottom: 1px solid #bbb;
}
.tabla-pagos td {
  text-align: center;
  border-bottom: 1px solid #bbb;
}
.mensaje-sin-detalle {
  padding: 1rem;
}
.center-text {
  display: flex;
  align-items: center;
  justify-content: center;
}
.importe {
  text-align: right;

}
</style>
